import { render, staticRenderFns } from "./pricing_strategy.vue?vue&type=template&id=4368604c&"
import script from "./pricing_strategy.vue?vue&type=script&lang=js&"
export * from "./pricing_strategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports